/* eslint-disable class-methods-use-this */
import RuntimeConfigNameRetriever from './RuntimeConfigNameRetriever'
import RuntimeConfigStore from './RuntimeConfigStore'

import RuntimeConfig from '../model/RuntimeConfig'

export default class RuntimeConfigBuilder {
  public async getRuntimeConfig(): Promise<RuntimeConfig> {
    const configName = await new RuntimeConfigNameRetriever().retrieveConfigName()
    const runtimeConfig = new RuntimeConfigStore().getRuntimeConfig(configName)
    return runtimeConfig
  }
}
